import React from "react";
import { RichText } from "prismic-reactjs";
import ReactPlayer from "react-player";

export default class Podcast extends React.Component {
  render() {
    const { title, coverUrl, fileUrl } = this.props;

    return (
      <div className="row mb-5">
        <div className="col-3">
          <img src={coverUrl} className="btn-block img-fluid" alt="" />
        </div>
        <div className="col-9">
          {title.length > 0 && (
            <p className="mt-0">
              <strong>{RichText.asText(title)}</strong>
            </p>
          )}
          <ReactPlayer
            url={fileUrl}
            controls
            className="react-player-podcast"
            width="100%"
            height="100%"
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/slices/Podcast.js